// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__wyAaq","head":"Table_head__3yo2D","col":"Table_col__1o4o5"};